import React from 'react';
import { getOrganizationList } from '../../../../models/organization';
import { getWalletUsers } from '../../../../models/users';
import HeaderBanner from '../../../common/HeaderBanner';
import i18n from '../../../../i18n';
import { SideBar } from '../../sidebar';
import FilterSection from '../../../common/Filter';
import Dropdown from '../../../common/DropDown';
import { selectStyles } from '../../../../styles/components/js/selectStyle';
import { TableSkeleton } from '../../../common/skelton/TableSkelton';
import NoData from '../../../common/NoData';
import { ArrowLeft, Check, X } from 'lucide-react';
import Select from 'react-select';
import { getEnrollments } from './services/managementService';
import DataTable from 'react-data-table-component';
import { tableStyles } from '../../../../styles/components/js/tableStyle';
import { withRouter } from '../../../../hoc/withRouter';
import StatusTabs from '../../../common/StatusTab';
import { formatDate } from '../../../../utils/common';
import { getLoggedUser } from '../../../../state/user';

const user = getLoggedUser();
class EnrollmentList extends React.Component {
  constructor() {
    super();
    this.state = {
      search: {
        client: '',
        bidder: null,
      },
      clients: [],
      customers: [],
      enrolments: [],
      showUserPopUp: false,
      isloading: false,
      limit: 15,
      page: 1,
      statusData: [
        { key: 'paid', label: 'Paid', count: 0 },
        { key: 'stratergy', label: 'Strategy', count: 0 },
      ],
      type: 'paid',
      startDate: null,
      endDate: null,
    };

    this.handleSearchChange = this.handleSearchChange.bind(this);
  }
  componentDidMount() {
    window.scrollTo(0, 0);
    // Parse URL query params
    const params = new URLSearchParams(window.location.search);
    const search = {
      client: params.get('client') || '',
      bidder: params.get('bidder') || null,
    };
    const type = params.get('type') ?? (user.role !== 'C' ? 'paid' : null);
    const page = parseInt(params.get('page')) || 1;
    const limit = parseInt(params.get('limit')) || 15;
    const startDate = params.get('startDate') || null;
    const endDate = params.get('endDate') || null;

    this.setState({ search, page, limit, type, startDate, endDate }, () => {
      this.getAllOrganization();
      this.getBidders();
      this.loadEnrollments();
    });
  }

  // Update URL without refreshing page
  updateUrlQuery(q) {
    const queryString = new URLSearchParams(
      Object.fromEntries(Object.entries(q).filter(([_, v]) => v !== '' && v !== null))
    ).toString();
    window.history.replaceState(null, '', `${window.location.pathname}?${queryString}`);
  }
  async loadEnrollments() {
    this.setState({ isloading: true });
    let { limit, page, type, startDate, endDate } = this.state;
    let { client, bidder } = this.state.search;
    const q = {
      page: page,
      limit: limit,
    };
    if (type) q.type = type;
    if (client) q.client = client;
    if (bidder) q.bidder = bidder;
    if (startDate) q.startDate = startDate;
    if (endDate) q.endDate = endDate;

    // Update URL
    this.updateUrlQuery(q);

    let response = await getEnrollments(q);
    if (response.success) {
      let enrolments = response.data;
      let { total, paid, stratergy } = response.meta;
      this.setState({
        enrolments,
        total,
        statusData: [
          { key: 'paid', label: 'Paid', count: paid },
          { key: 'stratergy', label: 'Strategy', count: stratergy },
        ],
        isloading: false,
      });
    }
    this.setState({ isloading: false });
  }
  async getAllOrganization() {
    const response = await getOrganizationList();
    let clients = response.data;
    this.setState({ clients });
  }

  async getBidders() {
    this.setState({ bidder_loading: true });
    const response = await getWalletUsers();
    let data = response.data;
    if (response.success) {
      const customers = data.map((item) => {
        return {
          value: item.id,
          label: item.name + ' (' + item.username + ')',
        };
      });

      this.setState({ bidder_loading: false });
      this.setState({ customers: customers });
    } else {
      this.setState({ bidder_loading: false });
    }
  }

  getColumns() {
    const { currentPage = 1, limit = 15 } = this.props;

    const baseColumns = [
      {
        name: '#',
        width: '70px',
        sortable: false,
        cell: (_, index) => (currentPage - 1) * limit + (index + 1),
      },
      {
        name: i18n.t('user_id'),
        width: '110px',
        selector: (row) => row.user_id,
        sortable: true,
      },
      {
        name: i18n.t('client_name'),
        width: '130px',
        cell: (row) => (
          <span className="highlight-table-value-secondary">
            {row.group.organization_deatils.organization_name}
          </span>
        ),
      },
      {
        name: i18n.t('group_name'),
        width: '130px',
        sortable: true,
        cell: (row) => (
          <span className="highlight-table-value-secondary">{row.group.group_name}</span>
        ),
      },
      {
        name: i18n.t('auction_name'),
        sortable: true,
        width: '160px',
        cell: (row) => <span className="highlight-table-value-secondary">{row.auction.title}</span>,
      },
      {
        name: i18n.t('bidder'),
        cell: (row) => <span className="highlight-table-value">{row.user.username}</span>,
      },
      {
        name: i18n.t('enrollment_fee'),
        width: '150px',
        cell: (row) => {
          if (row.group.is_grouped_enroll) {
            return row.group.amount ?? 0;
          } else {
            return row.auction.guarantee_amount ?? 0;
          }
        },
        sortable: true,
      },
      {
        name: i18n.t('enroll_at'),
        width: '110px',
        center: true,
        cell: (row) => <span>{formatDate(row.created_at)}</span>,
        wrap: true,
      },
      {
        name: i18n.t('group_enroll'),
        width: '110px',
        center: true,
        cell: (row) =>
          row.group.is_grouped_enroll ? (
            <Check size={16} className="icon-true" />
          ) : (
            <X size={16} className="icon-false" />
          ),
        sortable: true,
      },
    ];

    return baseColumns;
  }

  handleSearchChange = (e) => {
    const { name, value } = e.target;
    this.setState((prevState) => {
      const updatedSearch = { ...prevState.search, [name]: value };
      return { search: updatedSearch };
    });
  };

  handleSearch = () => {
    this.loadEnrollments();
  };

  handleClear = () => {
    const defaultSearch = {
      type: 'enroll',
      payment: '',
      client: '',
      group: '',
      bidder: null,
      refundStatus: this.state.refundStatus,
    };

    this.setState({ search: defaultSearch, groups: [], page: 1, selectedIds: [] }, () => {
      this.updateUrlQuery({ page: 1, limit: this.state.limit, type: 'enroll' });
      this.loadEnrollments();
    });
  };

  onChangePage = (page) => {
    this.setState({ page: page }, () => {
      this.loadEnrollments();
    });
  };

  onChangeRowsPerPage = (limit) => {
    this.setState({ limit: limit, page: 1 }, () => {
      this.loadEnrollments();
    });
  };

  handleCancel = () => {
    this.setState({
      showConfirm: false,
      confirmAction: null,
      selectedIds: [],
      rejectNote: null,
      rejectNoteError: null,
    });
  };

  handleTabChange = (key) => {
    this.setState({ type: key }, () => {
      this.loadEnrollments();
    });
  };

  render() {
    const { clients, customers } = this.state;

    return (
      <React.Fragment>
        <HeaderBanner title={i18n.t('enrollment_overview')} />
        <section className="dashboard-section">
          <div className="container">
            <div className="row">
              <div className="col-xl-3 col-lg-12 col-md-12">
                {!this.state.hideSidebar && <SideBar />}
              </div>
              <div
                className={
                  this.state.hideSidebar
                    ? 'col-xl-12 col-lg-12 col-md-12'
                    : 'col-xl-9 col-lg-12 col-md-12'
                }
              >
                <div className="card">
                  <div className="card-header">
                    <div className="expand-dashboard">
                      <span
                        style={{ fontSize: '1rem', marginRight: '0.5rem', cursor: 'pointer' }}
                        onClick={() => {
                          this.setState({
                            hideSidebar: !this.state.hideSidebar,
                          });
                        }}
                      >
                        {this.state.hideSidebar && <i className="icon-size-actual"></i>}
                        {!this.state.hideSidebar && <i className="icon-size-fullscreen"></i>}
                      </span>
                    </div>
                    {/* Back Button */}
                    <button
                      className="button1 button1-gradient button1-back"
                      onClick={() =>
                        this.props.navigate(user.role === 'C' ? '/client-dashboard' : '/management')
                      }
                    >
                      <ArrowLeft size={18} className="icon" />
                      <span>Back</span>
                    </button>
                  </div>
                  <div className="card-body">
                    {user.role !== 'C' && (
                      <>
                        <StatusTabs
                          tabs={this.state.statusData}
                          onTabChange={this.handleTabChange}
                          selected={this.state.type}
                        />
                        <FilterSection
                          loading={this.state.isloading}
                          onSearch={this.handleSearch}
                          onClear={this.handleClear}
                        >
                          {/* Client Dropdown */}
                          <Dropdown
                            name="client"
                            value={this.state.search.client}
                            onChange={this.handleSearchChange}
                            placeholder={i18n.t('client_name')}
                            empty={i18n.t('select_client')}
                            options={clients.map((c) => ({
                              value: c.id,
                              label: c.organization_name,
                            }))}
                          />

                          {/* Bider Dropdown */}
                          <div className="react-select-wrapper">
                            <Select
                              options={customers}
                              value={
                                customers.find((c) => c.value === this.state.search.bidder) || null
                              }
                              onChange={(selectedOption) => {
                                this.setState((prevState) => ({
                                  search: {
                                    ...prevState.search,
                                    bidder: selectedOption ? selectedOption.value : null,
                                  },
                                }));
                              }}
                              name="bidder"
                              styles={selectStyles}
                              menuPlacement="auto"
                              menuPortalTarget={document.body}
                              placeholder="Search Bidder"
                              className=""
                            />
                            {/* Only show label when there's a selected value */}

                            <label className="react-select-label">Bidder</label>
                          </div>
                        </FilterSection>
                      </>
                    )}

                    <div className="Data-Listing">
                      {this.state.isloading ? (
                        <TableSkeleton columns={6} rows={10} />
                      ) : this.state.enrolments.length ? (
                        <DataTable
                          responsive={true}
                          columns={this.getColumns()}
                          data={this.state.enrolments}
                          customStyles={tableStyles}
                          highlightOnHover
                          pagination
                          paginationServer
                          paginationTotalRows={this.state.total}
                          paginationPerPage={this.state.limit}
                          paginationDefaultPage={this.state.page}
                          paginationRowsPerPageOptions={[15, 25, 50, 100]}
                          paginationComponentOptions={{
                            rowsPerPageText: i18n.t('rows_per_page'),
                            rangeSeparatorText: i18n.t('out'),
                          }}
                          onChangePage={this.onChangePage}
                          onChangeRowsPerPage={this.onChangeRowsPerPage}
                        />
                      ) : (
                        <NoData
                          message="No payments available"
                          actionText={i18n.t('refresh')}
                          onAction={this.loadEnrollments.bind(this)}
                        />
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </React.Fragment>
    );
  }
}
export default withRouter(EnrollmentList);
